const dashboard = {
	title: "Dashboard",
};
export default dashboard;